module.exports = __webpack_public_path__ + "img/automobiles.73ae3c9f.svg";